<template>
  <div class="flex-list ">
    <h4 class="layoutheader">Please tick equipment required</h4>
    <div>
      <div role="group" aria-label="Basic checkbox toggle button group">
        <ul>
        <!-- {{ equirements }} -->
          <li v-for="(item) in equirements" :key="item">
            <div v-if="item.title != ''">
                <h4 style="margin: 0;"><input type="checkbox" @click='isCheckAll()'>{{ item.title }}</h4>
                <ul v-if="isCheck">
                    <li v-for="(i, ind) in item.list" :key="i">
                        <input type="checkbox" :id="ind" :value="i" v-model="picked" />
                        <label for="item">{{ i }} </label>
                    </li>
                </ul>
            </div>
            <div v-else>
                <br/>
                <li v-for="(i, ind) in item.list" :key="i">
                    <input type="checkbox" :id="ind" :value="i" v-model="picked" />
                    <label for="item" style="display: revert;">{{ i }} </label>
                </li>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['configuration'],
  data() {
    return {
      picked: [],
      id: '',
      equirements: [],
      isCheck: false,
    };
  },
  watch: {
    configuration() {
      this.equirements = this.configuration.whatisincluded;
    },

    picked() {
      //console.log('picked ', this.picked);
      this.$emit('config-picked', this.picked);
    }
  },

  methods: {
    isCheckAll(){
        // console.log('hello');
       this.isCheck = !this.isCheck;
    },
    OnClicked(ev) {
     // console.log('this layout', ev.target.id);
      this.id = ev.target.id;
    }
  }
};
</script>
<style scoped>
ul {
  list-style-type: none;
}

.layoutheader {
  margin: 1.5rem;
}
</style>
